import React from 'react';
import {Form, Modal} from "react-bootstrap";
import { Fab } from '@material-ui/core';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';
import CloseIcon from '@material-ui/icons/Close';
import AskCaryn from '../../Assets/Images/ask_caryn_beta_logo_desktop.png';
import CryptoJS from "crypto-js";

export default class AIKB extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            documentmessage:"",
            ModalpopUp:false,
            url:"",
            enlarge:false,
        }
    }
    openAskCaryn=(e)=> {
       e && e.preventDefault();
        let urlData={
          "memberId": "Agent Portal ID",
          "query": this.state.documentmessage,
          "ChannelUId":"agentportal",
        }
        let key = CryptoJS.enc.Utf8.parse("000102030405060708090a0b0c0d0e0f");
        let iv = CryptoJS.enc.Utf8.parse("4t7w9z$C&F)J@NcR");
        let input = CryptoJS.enc.Utf8.parse(JSON.stringify(urlData));
        var dataEncrypt = CryptoJS.AES.encrypt(input, key, { keySize: 256 / 32, iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }).toString();
        this.setState({url:`https://inf-labs.com/?isnav=false&data=${encodeURIComponent(dataEncrypt)}`},()=>{
          this.setState({ModalpopUp:true})
        })
     }
    render(){
        return (<div>
          <form onSubmit={this.openAskCaryn}>
             <div style={{ justifyContent:'space-between', display:'flex'}}>
                    <Form.Control value={this.state.documentmessage} required placeholder="Do you have a question?"  style={stylesheet.searchInputBox} onChange={e=>this.setState({documentmessage: e.target.value})}/>
                    <Fab style={{backgroundColor:"#543379", width:38, height:38, right:14, position: "relative", marginTop:5}} type="submit" onClick={()=>this.openAskCaryn(false)}>
                                <img width="37" src={require('../../Assets/Images/carynIcon.jpg')} />
                    </Fab>
            </div>
            </form>
            <Modal size={this.state.enlarge?"xl":"lg"} show={this.state.ModalpopUp} onHide={() => this.setState({ModalpopUp: false, documentmessage:""})} backdrop="static" >
                        <Modal.Header className="header-container">
                              <div className="logo"> 
                                  <img src={AskCaryn} width="95%"/>
                              </div>
                              <div className="caption">Your AI-Powered Assistant</div>
                              <div className="icons-header">
                                {this.state.enlarge?<FullscreenExitIcon style={{color:'white', cursor:'pointer'}} onClick={()=>this.setState({enlarge:false})}/>:<FullscreenIcon style={{color:'white', cursor:'pointer'}} onClick={()=>this.setState({enlarge:true})}/>}
                                <CloseIcon style={{color:'white', marginLeft:10, cursor:'pointer'}} onClick={() => this.setState({ModalpopUp: false, documentmessage:""})}/>
                              </div>
                        </Modal.Header>     
                                 <iframe height={this.state.enlarge?"550px":"500px"} width="100%" src={this.state.url}></iframe>
                            
                </Modal>
        </div>)
    }
}
const stylesheet={
    searchInputBox:{
        borderRadius:40, 
        paddingRight:32, 
        paddingLeft:12,
        width:'100vw', 
        borderColor:'#4146d2', 
        borderWidth:'revert',
        marginBottom:10,
        marginTop:5,
        marginRight:-9
    }
  }